import React, { Children } from 'react';
import { Carousel } from 'tradera/components/carousel/carousel';
import {
    LeftButton,
    RightButton
} from 'tradera/components/carousel/carousel-buttons';
import { CarouselContent } from 'tradera/components/carousel/carousel-content';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { useIsTablet } from 'tradera/hooks/use-is-tablet';

const useGetGridSlidesPerRow = (numberOfEntries) => {
    const isMobile = useIsMobile();
    const isTablet = useIsTablet();

    switch (numberOfEntries) {
        case 2:
            return { rows: 1, numberCarouselCards: 2 };

        case 4:
            if (isTablet || isMobile)
                return { rows: 2, numberCarouselCards: 2 };
            return { rows: 1, numberCarouselCards: 4 };

        case 6:
            if (isMobile || isTablet)
                return { rows: 2, numberCarouselCards: 2 };
            return { rows: 1, numberCarouselCards: 6 };

        case 8:
            if (isMobile || isTablet)
                return { rows: 2, numberCarouselCards: 2 };
            return { rows: 2, numberCarouselCards: 4 };

        default:
            if (isTablet || isMobile)
                return { rows: 2, numberCarouselCards: 2 };
            return { rows: 2, numberCarouselCards: 6 };
    }
};

export const PopCatGrid = ({ children }) => {
    const isMobile = useIsMobile();
    const numberOfChildren = Children.count(children);

    const { rows, numberCarouselCards } =
        useGetGridSlidesPerRow(numberOfChildren);

    return (
        <Carousel
            id="pop-cat-grid-carousel"
            numberItemsToShow={numberCarouselCards}
            numberItemsToScroll={numberCarouselCards}
            rows={rows}
            showScrollbar={isMobile}
            className="mx-0 mx-md-3 mx-lg-2 mx-xl-0">
            <LeftButton size="md" />
            <CarouselContent className="pb-1 pb-md-0">
                {children}
            </CarouselContent>
            <RightButton size="md" />
        </Carousel>
    );
};
